module.exports = __webpack_public_path__ + "static/media/3_.34f97ecb.png";